import { render, staticRenderFns } from "./SignDocuments.vue?vue&type=template&id=04f30ce1"
import script from "./SignDocuments.vue?vue&type=script&lang=js"
export * from "./SignDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports